import { HighlightedTextConfig } from '../HighlightedText';
import { InternalBreadcrumbsProps, Segment, SegmentIcon } from './types';

export const makeSegment = (
  highlightedText: HighlightedTextConfig,
  icon: SegmentIcon
): Segment => ({
  ...highlightedText,
  icon,
  gap: icon.rightMargin,
});

export const toHighlightedTextConfig = (
  breadcrumb: string | HighlightedTextConfig
): HighlightedTextConfig => {
  if (typeof breadcrumb === 'string') {
    return { text: breadcrumb };
  }
  return breadcrumb;
};

export const toSegments = (
  breadcrumbs: InternalBreadcrumbsProps['breadcrumbs'],
  leadingIcon: SegmentIcon,
  dividerIcon: SegmentIcon
): Segment[] =>
  breadcrumbs
    .map(toHighlightedTextConfig)
    .map((highlightedText, index) =>
      makeSegment(highlightedText, index === 0 ? leadingIcon : dividerIcon)
    );
